import { Col, Row, Switch } from 'antd';
import { useState } from 'react';
import {
    ScriptSureUserAdminLevel,
    ScriptSureUserPermissionType,
    ScriptSureUserWithDetailsDto,
    UserWithDetailsDto,
} from '../../models/UserResponses';
import { Utility } from '../../utilities/Utility';

type Props = {
    data: ScriptSureUserWithDetailsDto;
};

const OrganizationUserImportDetails: React.FC<Props> = ({ data }) => {
    const getUserPermission = (type: ScriptSureUserPermissionType) => {
        if (type === ScriptSureUserPermissionType.Provider) return 'Provider';

        if (type === ScriptSureUserPermissionType.SupportingStaff)
            return 'Supporting Staff';

        return 'N/A';
    };

    return (
        <div>
            <div className="fs-6 fw-semibold mb-4">Basic Information</div>
            <div className="d-flex flex-row gap-1 mb-3">
                <p className="me-3">ScriptSure’s User Status :</p>
                <Switch disabled={true} defaultChecked={data.isActive} />
                <p>{data.isActive ? 'Active' : 'Inactive'}</p>
            </div>
            <div className="mb-4">
                <Row>
                    <Col span={4} className="p-3 fs-7 border bg-grey">
                        Title/Suffix
                    </Col>
                    <Col span={4} className="p-3 fs-7 border bg-white">
                        {Utility.getStringOrNa(data.suffix)}
                    </Col>

                    <Col span={4} className="p-3 fs-7 border bg-grey">
                        First Name
                    </Col>
                    <Col span={4} className="p-3 fs-7 border bg-white">
                        {data.firstName}
                    </Col>

                    <Col span={4} className="p-3 fs-7 border bg-grey">
                        Last Name
                    </Col>
                    <Col span={4} className="p-3 fs-7 border bg-white">
                        {data.lastName}
                    </Col>

                    <Col span={4} className="p-3 fs-7 border bg-grey">
                        Email
                    </Col>
                    <Col span={8} className="p-3 fs-7 border bg-white">
                        {data.email}
                    </Col>

                    <Col span={4} className="p-3 fs-7 border bg-grey">
                        Phone Number
                    </Col>
                    <Col span={8} className="p-3 fs-7 border bg-white">
                        {Utility.getStringOrNa(data.phoneNumber)}
                    </Col>

                    <Col span={4} className="p-3 fs-7 border bg-grey">
                        User Type
                    </Col>
                    <Col span={8} className="p-3 fs-7 border bg-white">
                        {data.userType}
                    </Col>

                    <Col span={4} className="p-3 fs-7 border bg-grey">
                        Time Zone
                    </Col>
                    <Col span={8} className="p-3 fs-7 border bg-white">
                        {data.timeZone}
                    </Col>
                </Row>
            </div>
            <div className="d-flex flex-column gap-1 mb-4">
                <p className="fs-6 fw-semibold">User Permission</p>
                <Row>
                    <Col span={4} className="p-3 fs-7 border bg-grey">
                        Permission
                    </Col>
                    <Col span={20} className="p-3 fs-7 border bg-white">
                        {getUserPermission(data.userPermissionType)}
                    </Col>
                </Row>
            </div>

            <div className="d-flex flex-column mb-4">
                <p className="fs-6 fw-semibold">Administrator Permission</p>

                <div className="d-flex flex-row gap-1">
                    <Switch
                        disabled={true}
                        defaultChecked={
                            data.adminLevel ===
                                ScriptSureUserAdminLevel.Basic ||
                            data.adminLevel === ScriptSureUserAdminLevel.Full
                        }
                    />
                    <p>Basic Administrator</p>
                    <Switch
                        className="ms-5"
                        disabled={true}
                        defaultChecked={
                            data.adminLevel === ScriptSureUserAdminLevel.Full
                        }
                    />
                    <p>Full Administrator</p>
                </div>
            </div>

            <div className="d-flex flex-column mb-4">
                <p className="fs-6 fw-semibold">License Information</p>
                <Row>
                    <Col span={4} className="p-3 fs-7 border bg-grey">
                        NPI
                    </Col>
                    <Col span={4} className="p-3 fs-7 border bg-white">
                        {Utility.getStringOrNa(data.npi)}
                    </Col>

                    <Col span={4} className="p-3 fs-7 border bg-grey">
                        State License No
                    </Col>
                    <Col span={4} className="p-3 fs-7 border bg-white">
                        {Utility.getStringOrNa(data.stateLicense)}
                    </Col>

                    <Col span={4} className="p-3 fs-7 border bg-grey">
                        DEA
                    </Col>
                    <Col span={4} className="p-3 fs-7 border bg-white">
                        {Utility.getStringOrNa(data.dea)}
                    </Col>
                </Row>
            </div>

            <div className="d-flex flex-column mb-5 gap-1">
                <p className="fs-6 fw-semibold">Team(s) Assignment</p>
                {data.practices.map((practice) => (
                    <div>{practice.name}</div>
                ))}
            </div>
        </div>
    );
};

export default OrganizationUserImportDetails;
